module.exports = __webpack_public_path__ + "static/media/logo-blst.6a2f2803.png";